import { timeScaleTypesSet, continuousScaleTypesSet, discretizingScaleTypesSet, discreteScaleTypesSet } from '../parsers/scale/scaleCategories';
export function isContinuousScale(scale, scaleType) {
  return scale && continuousScaleTypesSet.has(scaleType);
}
export function isDiscretizingScale(scale, scaleType) {
  return scale && discretizingScaleTypesSet.has(scaleType);
}
export function isDiscreteScale(scale, scaleType) {
  return scale && discreteScaleTypesSet.has(scaleType);
}
export function isTimeScale(scale, scaleType) {
  return scale && timeScaleTypesSet.has(scaleType);
}